import classNames from 'classnames'
import { Children, useCallback, useEffect, useState } from 'react'
import { Carousel } from '../carousel'
import { PaginationDots } from '../pagination-dots'
import styles from './CarouselSlides.module.scss'
import type { CarouselSlidesProps } from './types'

const computeActiveIndex = (activeSlide: number, slidesNumber: number) => {
  return activeSlide >= 0 && activeSlide < slidesNumber ? activeSlide : 0
}

const CarouselSlides = ({
  className,
  children,
  activeSlide: initialActiveSlide = 0,
  paginationDotsAriaLabel,
  getDotAriaLabel,
  getSlideAriaLabel,
  ...rest
}: CarouselSlidesProps) => {
  const slidesNumber = Children.toArray(children).length
  const [activeSlide, setActiveSlide] = useState(initialActiveSlide)

  useEffect(() => {
    setActiveSlide(computeActiveIndex(initialActiveSlide, slidesNumber))
  }, [initialActiveSlide, slidesNumber])

  const handlePrev = useCallback(() => {
    setActiveSlide((prev) => computeActiveIndex(prev - 1, slidesNumber))
  }, [slidesNumber])

  const handleNext = useCallback(() => {
    setActiveSlide((prev) => computeActiveIndex(prev + 1, slidesNumber))
  }, [slidesNumber])

  const handlePageClick = (index: number) => {
    setActiveSlide(index)
  }
  return (
    <div className={classNames(styles['pintxo-carousel-slides'], className)}>
      <Carousel
        withButtons
        {...rest}
        role="tabpanel"
        onNext={handleNext}
        onPrevious={handlePrev}
        activeIndex={activeSlide}
        getSlideAriaLabel={getSlideAriaLabel}
      >
        {children}
      </Carousel>
      <PaginationDots
        aria-label={paginationDotsAriaLabel}
        index={activeSlide}
        onClick={handlePageClick}
        pages={slidesNumber}
        getDotAriaLabel={getDotAriaLabel}
      />
    </div>
  )
}

export default CarouselSlides
